<script setup lang="ts">
import type { ExtendedPrimitives } from '@/types/ExtendedPrimitives'

type Props = {
    props: {
        row: Record<string, ExtendedPrimitives>
        index: number
    }
    hasDetails?: boolean
}

defineProps<Props>()
</script>

<template>
    <tr class="detail" v-bind="$attrs">
        <td :colspan="Object.keys(props.row).length + (hasDetails ? 1 : 0)">
            <slot />
        </td>
    </tr>
</template>
